import { Serv_client } from './Serv.client'
import { always } from '../../../shared/lib/functional/function.no-deps'
import { timeout } from '../../../shared/lib/timeout.no-deps'
import memoizee from 'memoizee'

export const Serv_respondsToPing = memoizee(ping, { maxAge: 2000 })

function ping() {
    return Promise.race([Serv_client.ping().then(always(true)).catch(always(false)), timeout(5000).then(always(false))])
}
